<template>
  <ui-card class="screening-result-item">
    <ui-heading tag="h3" class="heading" no-top-margin>
      <router-link variant="primary" :to="detailsRoute">
        {{ name }}
      </router-link>
    </ui-heading>
    <ui-field
      label-position="top"
      v-if="hasItems(countries)"
      :label="$t('screening.countries')"
    >
      {{ countriesFullName }}
    </ui-field>
    <ui-field
      label-position="top"
      v-if="gender"
      :label="$t('screening.gender')"
    >
      {{ gender }}
    </ui-field>
    <ui-field
      label-position="top"
      v-if="matchScore"
      :label="$t('screening.matchScore')"
    >
      {{ matchScore }}
    </ui-field>
    <ui-field
      label-position="top"
      v-if="hasItems(birthDates)"
      :label="$t('screening.birth_dates')"
    >
      <li
        v-for="birthDate in birthDates"
        class="value-list-item"
        :key="birthDate"
      >
        {{ birthDate }}
      </li>
    </ui-field>
    <ui-field
      label-position="top"
      v-if="hasItems(dataSets)"
      :label="$t('screening.data_sets')"
    >
      <li class="value-list-item" v-for="dataSet in dataSets" :key="dataSet">
        {{ dataSet }}
      </li>
    </ui-field>
    <div class="footer">
      <router-link variant="primary" :to="detailsRoute">
        Details
      </router-link>
    </div>
  </ui-card>
</template>

<script>
import { ROUTE_NAMES } from "@/router/constants";
import countryCodes from "../assets/isoCodes.json";

export default {
  props: {
    resourceId: { type: String, required: true },
    name: String,
    gender: String,
    matchScore: Number,
    countries: Array,
    birthDates: Array,
    dataSets: Array
  },
  computed: {
    detailsRoute() {
      return {
        name: ROUTE_NAMES.SANCTION_DETAILS,
        params: { id: this.resourceId },
        query: this.$route.query
      };
    },
    hitCount() {
      return this.screeningHits?.length;
    },
    countriesFullName() {
      const countryNames = this.countries.map(countryCodeIso2 => {
        const countryIso3Code = countryCodes[countryCodeIso2];
        return this.$t(`countries.${countryIso3Code}`);
      });
      return countryNames.join(", ");
    }
  },
  methods: {
    hasItems(arr) {
      return arr?.length > 0;
    }
  }
};
</script>

<style>
.screening-result-item {
  display: flex;
  flex-direction: column;
}
.hr {
  width: 100%;
}
.value-list {
  padding: 0;
  margin: 0 -0.2rem;
  list-style: none;
}
.value-list-item {
  display: inline-block;
  padding: 0.1rem 0.2rem;
  margin: 0.2rem;
  font-weight: lighter;
  color: var(--text-brand);
  border: 1px solid var(--text-brand);
  border-radius: 0.25rem;
}
.heading {
  color: var(--brand-primary);
}
.footer {
  margin-top: auto;
}
</style>
